import { Pipe, PipeTransform } from '@angular/core';
import { Config, TranslateService } from '@app/services';
import { formatAppCurrency, formatAppNumber } from '@app/shared/utils/number';

@Pipe({
  name: '_number',
  pure: true,
  standalone: true,
})
export class NumberPipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  transform(value: unknown, decimals: number = 2, mode: string = '', trailing: boolean = false): string {
    this.translateService.currentLanguage();
    const isCurrency: boolean = mode === 'currency';
    const formatted: string = isCurrency ? formatAppCurrency(value, decimals) : formatAppNumber(value, decimals);
    if (!trailing) {
      return formatted;
    }
    const config: Config = this.translateService.getConfig;
    const decimalSeparator: string = isCurrency ? config.currency.decimal : config.number.decimal;
    return this.removeTrailingZeros(formatted, decimalSeparator);
  }

  private removeTrailingZeros(value: string, separator: string): string {
    if (!value.includes(separator)) {
      return value;
    }
    let normalized: string = value;
    while ((normalized.endsWith('0') || normalized.endsWith(separator)) && normalized.includes(separator)) {
      normalized = normalized.slice(0, -1);
    }
    return normalized;
  }
}
